import { render } from "./Sticky.vue?vue&type=template&id=1d70da9d&scoped=true"
import script from "./Sticky.vue?vue&type=script&lang=js"
export * from "./Sticky.vue?vue&type=script&lang=js"

import "./Sticky.vue?vue&type=style&index=0&id=1d70da9d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d70da9d"]])

export default __exports__